import Column from 'Components/Base/Column'
import Icon from 'Components/Base/Icon'
import Row from 'Components/Base/Row'
import Typography from 'Components/Base/Typography'
import dayjs from 'dayjs'
import React from 'react'
import styled, { useTheme } from 'styled-components'
import { Message } from 'types/MessagingCenter'

interface Props {
  messages: Message[]
  currentMessage: Message
  handleMessageSelect: (message: Message) => void
}

export default function MessagingRow({ messages, currentMessage, handleMessageSelect }: Props) {
  const theme = useTheme()
  return (
    <div style={{ marginTop: 10, overflowY: 'scroll', height: '85%', borderTop: '1px solid #E0E0E0' }}>
      {messages.length > 0 &&
        currentMessage &&
        messages.map(
          (row, index) =>
            row && (
              <div
                key={index}
                style={{
                  backgroundColor:
                    index ===
                    messages.findIndex(
                      (message) =>
                        message.triaInitiatedMessagePId === currentMessage?.triaInitiatedMessagePId &&
                        message.patientInitiatedMessagePId === currentMessage?.patientInitiatedMessagePId,
                    )
                      ? 'rgba(0, 103, 127, 0.26)'
                      : '#fff',
                  width: '100%',
                  margin: 'auto',
                  padding: '10px 20px',
                  borderBottom: '2px solid #E0E0E0',
                }}
                className="careplan-detail-document-item"
              >
                <Row
                  styles={{
                    width: '100%',
                    margin: 'auto',
                    cursor: 'pointer',
                    height: 115,
                    padding: '10px',
                  }}
                  onClick={() => handleMessageSelect(row)}
                >
                  <Row>
                    {row.hasNewMessage && (
                      <StyledBadge>
                        <div style={{ marginBottom: 2, marginRight: 10 }}></div>
                      </StyledBadge>
                    )}
                    <Column>
                      <Row
                        styles={{
                          textAlign: 'left',
                          width: '100%',
                        }}
                      >
                        <Typography styles={{ fontWeight: 'bold' }} size={14}>
                          {`${row?.subject.slice(0, 35)}${row?.subject.length > 35 ? '...' : ''}`}
                        </Typography>
                      </Row>
                      {/* this is the most recent messages first thirteen characters sliced with ellipses after */}
                      <Row
                        styles={{
                          textAlign: 'left',
                          width: '260px',
                          marginTop: 20,
                        }}
                      >
                        {row.conversations.length > 0 ? (
                          <Typography size={14}>{`${row?.conversations[row.conversations.length - 1]?.body.slice(0, 73)}${
                            row?.conversations[row.conversations.length - 1]?.body.length > 73 ? '...' : ''
                          }`}</Typography>
                        ) : (
                          <Typography size={14}>{`${row?.body.replace('|', ' ').slice(0, 73)}${row?.body.length > 73 ? '...' : ''}`}</Typography>
                        )}
                      </Row>
                    </Column>
                  </Row>
                  <Column styles={{ marginLeft: 'auto', marginTop: 0, width: 'fit-content' }}>
                    <Typography styles={{ fontWeight: 'bold' }}>{`${dayjs(row?.messageDate).format('ddd, MMM DD')}`}</Typography>
                    <Typography styles={{ marginLeft: 'auto' }}>{`${dayjs(row?.messageDate).format('h:mm A')}`}</Typography>
                    <Row styles={{ marginLeft: 'auto', marginTop: 5 }}>
                      {(row.triaAttachments.filter((a) => a.attachmentType === 2).length > 0 ||
                        row.conversations.find((m) => m.fromTria && m.patientAttachments.filter((a) => a.attachmentType === 2).length > 0)) && (
                        <>
                          <Icon name="attachment" />
                        </>
                      )}
                      {(row.triaAttachments.filter((a) => a.attachmentType === 1).length > 0 ||
                        row.conversations.find((m) => m.fromTria && m.patientAttachments.filter((a) => a.attachmentType === 1).length > 0)) && (
                        <>
                          <Icon name="linkHorizontal" styles={{ marginLeft: 10 }} />
                        </>
                      )}
                      {(row.triaAttachments.filter((a) => a.attachmentType === 1).length > 0 ||
                        row.conversations.find((m) => m.fromTria && m.patientAttachments.filter((a) => a.attachmentType === 1).length > 0)) && (
                        <>
                          {row.triaAttachments.filter((a) => a.attachmentType === 1 && a.liked).length > 0 ||
                          row.conversations.find((m) => m.fromTria && m.patientAttachments.find((a) => a.attachmentType === 1 && a.liked)) ? (
                            <>
                              <Icon name="heart" styles={{ marginLeft: 10, color: theme.colors.charts.dangerousLow }} />
                            </>
                          ) : (
                            <>
                              <Icon name="heartOutline" styles={{ marginLeft: 10 }} />
                            </>
                          )}
                        </>
                      )}
                    </Row>
                  </Column>
                </Row>
              </div>
            ),
        )}
    </div>
  )
}

const StyledBadge = styled.div`
  height: 10px;
  min-width: 10px;
  width: fit-content;
  margin-left: -20px;
  margin-right: 10px;
  border-radius: 10px;
  background-color: #7a9a01;
  display: flex;
  align-items: center;
  justify-content: center;
`
